/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartnerStationDtoTimeZone } from './PartnerStationDtoTimeZone';
import {
    PartnerStationDtoTimeZoneFromJSON,
    PartnerStationDtoTimeZoneFromJSONTyped,
    PartnerStationDtoTimeZoneToJSON,
} from './PartnerStationDtoTimeZone';
import type { VehicleCategoryData } from './VehicleCategoryData';
import {
    VehicleCategoryDataFromJSON,
    VehicleCategoryDataFromJSONTyped,
    VehicleCategoryDataToJSON,
} from './VehicleCategoryData';

/**
 * 
 * @export
 * @interface AdditionalDriverInvitationPrebooking
 */
export interface AdditionalDriverInvitationPrebooking {
    /**
     * 
     * @type {number}
     * @memberof AdditionalDriverInvitationPrebooking
     */
    bookedForDate: number;
    /**
     * 
     * @type {number}
     * @memberof AdditionalDriverInvitationPrebooking
     */
    bookedUntilDate: number;
    /**
     * 
     * @type {VehicleCategoryData}
     * @memberof AdditionalDriverInvitationPrebooking
     */
    vehicleCategoryData: VehicleCategoryData;
    /**
     * 
     * @type {number}
     * @memberof AdditionalDriverInvitationPrebooking
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDriverInvitationPrebooking
     */
    address: string;
    /**
     * 
     * @type {PartnerStationDtoTimeZone}
     * @memberof AdditionalDriverInvitationPrebooking
     */
    timeZoneId: PartnerStationDtoTimeZone;
}

/**
 * Check if a given object implements the AdditionalDriverInvitationPrebooking interface.
 */
export function instanceOfAdditionalDriverInvitationPrebooking(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bookedForDate" in value;
    isInstance = isInstance && "bookedUntilDate" in value;
    isInstance = isInstance && "vehicleCategoryData" in value;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "address" in value;
    isInstance = isInstance && "timeZoneId" in value;

    return isInstance;
}

export function AdditionalDriverInvitationPrebookingFromJSON(json: any): AdditionalDriverInvitationPrebooking {
    return AdditionalDriverInvitationPrebookingFromJSONTyped(json, false);
}

export function AdditionalDriverInvitationPrebookingFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalDriverInvitationPrebooking {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bookedForDate': json['bookedForDate'],
        'bookedUntilDate': json['bookedUntilDate'],
        'vehicleCategoryData': VehicleCategoryDataFromJSON(json['vehicleCategoryData']),
        'locationId': json['locationId'],
        'address': json['address'],
        'timeZoneId': PartnerStationDtoTimeZoneFromJSON(json['timeZoneId']),
    };
}

export function AdditionalDriverInvitationPrebookingToJSON(value?: AdditionalDriverInvitationPrebooking | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bookedForDate': value.bookedForDate,
        'bookedUntilDate': value.bookedUntilDate,
        'vehicleCategoryData': VehicleCategoryDataToJSON(value.vehicleCategoryData),
        'locationId': value.locationId,
        'address': value.address,
        'timeZoneId': PartnerStationDtoTimeZoneToJSON(value.timeZoneId),
    };
}

